module.exports = __webpack_public_path__ + "static/img/section_health_heartbeat_watermark_bg.370ee1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/section_health_heartbeat_watermark_bg.png
// module id = 7ZqW
// module chunks = 1